import { useState } from "react";

interface CopyFieldProps {
  value: string;
  /** Optional prefix shown but not part of the copyable command, e.g. "$". */
  prompt?: string;
  /** Render as a multi-line code block instead of an inline field. */
  multiline?: boolean;
  label?: string;
}

export function CopyField({ value, prompt, multiline, label }: CopyFieldProps) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      // Clipboard API unavailable (e.g. insecure context) — no-op.
      // TODO: fall back to a manual-select state.
    }
  }

  return (
    <div className={`copyfield${multiline ? " copyfield--block" : ""}`}>
      {label && <span className="copyfield-label">{label}</span>}
      <div className="copyfield-row">
        <code className="copyfield-code">
          {prompt && <span className="copyfield-prompt">{prompt} </span>}
          {value}
        </code>
        <button
          type="button"
          className="copyfield-btn"
          onClick={copy}
          aria-label="Copy to clipboard"
        >
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
}
